import React from 'react';
import { Column } from '@ant-design/plots';

const Downloadsbycampaign = (props) => {
  const data = [
  ];
  props.campaignData.forEach((value) => {

    var campaignName = value.position;
    var length = 9;
    var trimmedCampaignName = campaignName.substring(0, length) + '...';

    data.push(
      {
        'CampaignTrimmed': trimmedCampaignName,
        'Campaign': value.position,
        'Downloads': parseInt(value.downloads),
      }
    )
  })

  const config = {
    data,
    xField: 'CampaignTrimmed',
    yField: 'Downloads',
    // label: {
    //   position: 'top',
    //   style: {
    //     fill: '#000000',
    //     // fontSize: 12
    //   },
    // },
    meta: false,
    color: '#667AFF',
    isStack: true,
    axis: {
      x: {

        // This part is the configuration of the grid lines 
        // grid: true,  //Whether to show grid lines   
        // gridLineWidth: 2,  //gridline width   
        //This part is the configuration of the axis 
        line: true,  //Whether the axis is shown   
        lineLineWidth: 1,  //width of axis   
        lineStroke: '#666',  //axis Stroke   
        //This part is the configuration of the axis scale 
        tick: false,  //whether the scale is displayed   
        tickLineWidth: 2,  //width of scale line   
        tickLength: 2,  //gradeline length   
        tickStroke: '#666',  // tick-line colour   
        // This part is the configuration of the axis label 
        label: true,  //Whether the scale value is displayed   
        labelFontSize: 9,  // Scale value text size   
        // labelFill: '#009900',  //scale-valuefontcolor   
        labelFontWeight: 500,  // Scale value font thickness   
      },
      y: {

        // This part is the configuration of the grid lines 
        grid: true,  //Whether to show grid lines   
        gridLineWidth: 1,  //gridline width   
        //This part is the configuration of the axis 
        line: true,  //Whether the axis is shown   
        lineLineWidth: 0,  //width of axis   
        lineStroke: '#666',  //axis Stroke   
        //This part is the configuration of the axis scale 
        tick: false,  //whether the scale is displayed   
        tickLineWidth: 2,  //width of scale line   
        tickLength: 2,  //gradeline length   
        tickStroke: '#3366ff',  // tick-line colour   
        // This part is the configuration of the axis label 
        label: true,  //Whether the scale value is displayed   
        labelFontSize: 9,  // Scale value text size   
        // labelFill: '#009900',  //scale-valuefontcolor   
        labelFontWeight: 500,  // Scale value font thickness  
        gridLineDash: [0, 0]
      }
    },
    scrollbar: {
      type: 'horizontal',
      style: {
        trackColor: '#F0FAFF',
        thumbColor: '#D7F2FF'
      },
    },
    tooltip: {
      showTitle: false,
      items: ['Campaign', 'Downloads'],
    },
    scale: {
      x: { "type": "band", padding: 0.5 }
    },
    style: {
      maxWidth: 15,
      minWidth: 15,
      fill: '#667AFF',
      radiusTopLeft: 10,
      radiusTopRight: 10,
      radiusBottomLeft: 10,
      radiusBottomRight: 10,
    },
    height: 260,
  };
  if (data.length > 0) {
    return <Column {...config} />;
  }

};

export default Downloadsbycampaign;
